
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.61 2c2.758 0 4.387 1.759 4.387 4.745v.033h-3.388c-1.576.003-2.853 1.387-2.856 3.095-.002 1.711 1.276 3.101 2.856 3.103H18v.272C18 16.234 16.372 18 13.615 18H6.387C3.629 18 2 16.234 2 13.248V6.745C2 3.759 3.63 2 6.387 2h7.224zm-3.303 3.445H5.792c-.336.001-.608.296-.61.66-.001.366.272.665.61.666h4.52c.338-.001.611-.3.61-.666-.002-.366-.278-.662-.616-.66z","fill":"#94A3B8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.23 10.264c.167.845.834 1.44 1.596 1.425h2.6c.317 0 .574-.292.574-.653v-2.25c0-.36-.257-.652-.574-.653h-2.661c-.867.003-1.566.802-1.565 1.787 0 .115.01.23.03.344zm2.37-.353c0 .491-.358.889-.8.889-.442 0-.8-.398-.8-.889 0-.49.358-.889.8-.889.442 0 .8.398.8.89z","fill":"#94A3B8"}})])
          )
        }
      }
    